var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3352_8003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13.75H19C19.6858 13.75 20.25 14.3142 20.25 15V19C20.25 19.6858 19.6858 20.25 19 20.25H5C4.31421 20.25 3.75 19.6858 3.75 19V15C3.75 14.3142 4.31421 13.75 5 13.75ZM4.25 17C4.25 18.5142 5.48579 19.75 7 19.75C8.51421 19.75 9.75 18.5142 9.75 17C9.75 15.4858 8.51421 14.25 7 14.25C5.48579 14.25 4.25 15.4858 4.25 17ZM5 3.75H19C19.6858 3.75 20.25 4.31421 20.25 5V9C20.25 9.68579 19.6858 10.25 19 10.25H5C4.31421 10.25 3.75 9.68579 3.75 9V5C3.75 4.31421 4.31421 3.75 5 3.75ZM4.25 7C4.25 8.51421 5.48579 9.75 7 9.75C8.51421 9.75 9.75 8.51421 9.75 7C9.75 5.48579 8.51421 4.25 7 4.25C5.48579 4.25 4.25 5.48579 4.25 7Z",
    stroke: "#717171",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3352_8003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetSidebar);
export default __webpack_public_path__ + "static/media/asset_sidebar.967db9a554b5b2d7137951cac6fc6fe5.svg";
export { ForwardRef as ReactComponent };